/**
 * @file The app's single theme provider: Mantine theme + color scheme
 * persistence + MUI bridge. All scheme state flows from here — components
 * read it via useThemeMode()/useThemeColors() and the --dt-* CSS variables.
 */
import PropTypes from 'prop-types';
import { MantineProvider, localStorageColorSchemeManager } from '@mantine/core';
import { mantineTheme, cssVariablesResolver } from './index';
import MuiThemeBridge from './MuiThemeBridge';

// Key is mirrored by the FOUC guard script in frontend/index.html.
const colorSchemeManager = localStorageColorSchemeManager({ key: 'driptours-color-scheme' });

const ThemeProvider = ({ children }) => (
  <MantineProvider
    theme={mantineTheme}
    cssVariablesResolver={cssVariablesResolver}
    defaultColorScheme="light"
    colorSchemeManager={colorSchemeManager}
  >
    <MuiThemeBridge>{children}</MuiThemeBridge>
  </MantineProvider>
);

ThemeProvider.propTypes = {
  children: PropTypes.node
};

export default ThemeProvider;
